import { confirmActionWithSuspiciousItems } from 'Cloud/Application/Suspicious';
import { logger } from 'lib/logger';

import { fixAttachUrl } from './attaches.helpers';
import type { AttachesItem } from './attaches.types';

export const downloadAttachItem = (item: AttachesItem): Promise<void> => {
    // need to clone item because it will be modified inside
    return confirmActionWithSuspiciousItems({ ...item }, 'download').then(function (): void {
        const downloadUrl = item?.url?.download;

        if (downloadUrl) {
            window.open(fixAttachUrl(downloadUrl, true), '_self');
        } else {
            logger.error('can not download');
        }
    });
};
